// src/components/ChildData/Lastpurchasetb.jsx
import React from "react";

const Lastpurchasetb = ({ data = [] }) => {
    if (!data.length)
        return <p className="p-4 text-center text-gray-500">No data available</p>;

    return (
        <div className="p-4 overflow-x-auto">
            <table className="min-w-full border border-blue-500 bg-white shadow-md rounded-lg overflow-hidden">
                <thead className="bg-[#267CB8] text-white">
                    <tr>
                        <th className="px-4 py-2 text-center">S.No</th>
                        <th className="px-4 py-2 text-left">Problem Area</th>
                        <th className="px-4 py-2 text-left">PPL</th>
                        <th className="px-4 py-2 text-left">PL</th>

                        <th className="px-4 py-2 text-center">Count</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, i) => (
                        <tr
                            key={i}
                            className={i % 2 === 0 ? "bg-white" : "bg-blue-50"}
                        >
                            <td className="px-4 py-2 border-t border-blue-200 text-center">{i + 1}</td>
                            <td className="px-4 py-2 border-t border-blue-200 text-left">
                                {item.key}
                            </td>
                            <td className="px-4 py-2 border-t border-blue-200 text-left">
                                {item.key[1]}
                            </td>
                            <td className="px-4 py-2 border-t border-blue-200 text-left">
                                {item.key[2]}
                            </td>
                            <td className="px-4 py-2 border-t border-blue-200 text-center">
                                {item.doc_count ?? 0}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Lastpurchasetb;
